import React from 'react';
import PartnerDashboard from '../components/dashboard/PartnerDashboard';

const PartnerDashboardPage = () => {
  return <PartnerDashboard />;
};

export default PartnerDashboardPage;

